<p-popover
  class=""
  #op
  [dt]="{ overlayArrowOffset: '100%' }"
  [styleClass]="'popover--no-arrow popover--ml-15px'"
>
  <div class="flex flex-col gap-1 w-[25rem] max-h-64 overflow-auto">
    <div
      *ngFor="let notification of tenantNotifications"
      class="flex items-start gap-1 p-1 cursor-pointer hover:bg-emphasis transition-all"
      (click)="notificationClicked(notification)"
      [ngClass]="{
        'bg-emphasis': false,
      }"
    >
      <div class="relative mt-1">
        <div class="flex justify-between flex-col">
          <span
            [class.invisible]="!!notification.seenAt"
            class="bg-red-600 text-white pt-0 pr-2 pl-2 pb-0 text-xs text-center"
            >{{ "tenantNotifications.ui.newLabel" | translate }}</span
          >
          <i class="{{ getNotificationIcon(notification) }} p-3 text-xl"></i>

          <!-- <p-button
            icon="pi pi-eye"
            [rounded]="true"
            [text]="true"
            (click)="
              removeNotificationClicked(notification);
              $event.preventDefault();
              $event.stopPropagation()
            "
          /> -->
        </div>
        <!--<p-badge
          *ngIf="chat.active !== undefined"
          [severity]="chat.active ? 'success' : 'danger'"
          class="absolute top-0 right-0 p-[1px] bg-surface-0 dark:bg-surface-950 rounded-full flex items-center justify-center"
        />

        <p-avatar
          [image]="chat.image"
          [label]="!chat.image ? chat.capName : ''"
          [ngClass]="{
            '!bg-primary-100 !text-primary-950': !chat.image,
          }"
          styleClass="text-base font-medium flex"
          size="large"
          shape="circle"
        /> -->
      </div>
      <div class="flex-1">
        <div class="flex items-start gap-1 justify-between">
          <div class="text-color font-medium leading-6 flex-1 flex-wrap">
            {{ notification.titleCode | translate }}
          </div>
          <div class="text-sm text-muted-color leading-5">
            {{ notification.createdAt | date: "mediumDate" }}
          </div>
        </div>
        <div class="flex items-center gap-5 justify-between mt-1">
          <div class="text-muted-color text-sm leading-5">
            {{ notification.descriptionCode | translate }}
          </div>
        </div>
        <div
          *ngIf="notification.entityName"
          class="flex items-center gap-5 justify-between mt-1"
        >
          <div class="text-muted-color text-sm leading-5 font-semibold">
            {{ notification.entityName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</p-popover>
<p-button
  severity="secondary"
  outlined
  (click)="op.toggle($event)"
  class="overflow-visible"
>
  <p-overlayBadge
    *ngIf="countNotSeen"
    severity="danger"
    [value]="countNotSeen"
    class="relative overflow-visible"
  >
    <i class="pi pi-bell pt-2"></i>
  </p-overlayBadge>

  <i *ngIf="!countNotSeen" class="pi pi-bell"></i>
</p-button>
